export default { sha: '6c41a3ebf3dae35187091d436644b3ae2973cd63', buildNumber: 'undefined' }
